import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "./theme/ThemeContext";
import { FontSizeProvider } from "./theme/FontSizeContext";
import { ColorProvider } from "./theme/ColorContext";
import { ZenModeProvider } from "./theme/ZenModeContext";
import { ReaderTypographyProvider } from "./theme/ReaderTypographyContext";
import { useTheme } from "./theme/ThemeContext";
import { getTheme } from "./theme/theme";
import Home from "./Home";
import About from "./About";
import ChapterDetail from "./ChapterDetail";
import CompareChapter from "./CompareChapter";
import ScrollToTop from "./components/ScrollToTop";
import AppHeader from "./components/AppHeader";
import { BibleProvider } from "./data/bibleContext";
import { AuthProvider } from "./firebase/authContext";
import NotesPage from "./components/Notes/NotesPage";
import ReadingHistoryPage from "./components/History/ReadingHistoryPage";
import CommunityNotesPage from "./components/Notes/CommunityNotesPage";
import SharedNoteDetail from "./components/Notes/SharedNoteDetail";
import AdminPortal from "./components/Admin/AdminPortal";
import ProfilePage from "./components/Profile/ProfilePage";
import { SocialProvider } from "./context/SocialContext";

export const ROUTER_FUTURE = {
  v7_startTransition: true,
  v7_relativeSplatPath: true,
};

const ThemedApp = () => {
  const { paperMode, accentColor } = useTheme();
  const theme = getTheme(paperMode, accentColor);

  return (
    <MuiThemeProvider theme={theme}>
      <ColorProvider>
        <CssBaseline />
        <Router future={ROUTER_FUTURE}>
          <SocialProvider>
            <ScrollToTop />
            <AppHeader>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/en" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/chapter/:chapterId" element={<ChapterDetail />} />
              <Route
                path="/en/chapter/:chapterId"
                element={<ChapterDetail />}
              />
              <Route path="/compare" element={<Home />} />
              <Route
                path="/compare/chapter/:chapterId"
                element={<CompareChapter />}
              />
              <Route path="/notes" element={<NotesPage />} />
              <Route path="/history" element={<ReadingHistoryPage />} />
              <Route path="/community" element={<CommunityNotesPage />} />
              <Route path="/shared/notes/:noteId" element={<SharedNoteDetail />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/admin" element={<AdminPortal />} />
            </Routes>
            </AppHeader>
          </SocialProvider>
        </Router>
      </ColorProvider>
    </MuiThemeProvider>
  );
};

const App = () => {
  return (
    <ThemeProvider>
      <FontSizeProvider>
        <ReaderTypographyProvider>
          <ZenModeProvider>
            <BibleProvider>
              <AuthProvider>
                <ThemedApp />
              </AuthProvider>
            </BibleProvider>
          </ZenModeProvider>
        </ReaderTypographyProvider>
      </FontSizeProvider>
    </ThemeProvider>
  );
};

export default App;
